import { FRONTEND_HOST } from "@/config/constants";
import { studentIdCall } from "@/helpers/api/service";
import {
  decodeToken,
  getStudentIdLS,
  getUUID,
  isWebView,
  setStudentIdLS,
} from "@/utils/auth";
import { useRouter } from "next/router";
import {
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";

export interface IUser {
  id?: number;
  isVip?: boolean;
  mobile?: string;
}

const AuthContext = createContext<{
  contextResolved?: boolean;
  user?: IUser;
  setUser?: Dispatch<SetStateAction<IUser | undefined>>;
  pseudoAuth?: boolean;
  studentId: string;
  refreshUser: () => boolean;
    }>({
      studentId: "",
      refreshUser: () => false,
    });

const AuthProvider = (props: { children: any }) => {
  const [user, setUser] = useState<IUser | undefined>();
  const [studentId, setStudentId] = useState<string>("");
  const [contextResolved, updateContextResolved] = useState<boolean>(false);
  const [pseudoAuth, setPseudoAuth] = useState<boolean>(false);

  const router = useRouter();
  const webView = props?.children?.props?.children?.[1]?.props?.children?.[0]?.props?.children?.props?.isWebView || isWebView();

  const refreshUser = () => {
    const user = decodeToken();
    if (!user?.id) {
      return false;
    }
    setUser(user);
    return true;
  }

  useEffect(() => {
    if (!global.window) {
      return;
    }
    const studentIdLS = getStudentIdLS();
    if (!studentIdLS) {
      const uuid = getUUID();
      const pageUrl = `${FRONTEND_HOST}/${router.asPath}`;
      studentIdCall(uuid, pageUrl).then((res: any) => {
        if (res.data?.student_id) {
          setStudentIdLS(res.data.student_id);
          setStudentId(res.data.student_id);
        }
      });
    } else {
      setStudentId(studentIdLS);
    }
    updateContextResolved(true);

    if (refreshUser()) return;

    const token = router.query.token;
    if (!token || !webView) return;

    setUser(decodeToken(token as string));
    setPseudoAuth(webView);
  }, []);

  useEffect(() => {
    if (!user?.isVip) {
      return;
    }
    window.googletag = window.googletag || ({} as typeof window.googletag);

    window.googletag.cmd = window.googletag.cmd || [];
    googletag.cmd.push(() => {
      googletag.destroySlots();
    });
  }, [user]);

  return (
    <AuthContext.Provider
      value={{
        contextResolved,
        user,
        setUser,
        pseudoAuth,
        studentId,
        refreshUser,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

const AuthConsumer = AuthContext.Consumer;

export { AuthContext, AuthProvider, AuthConsumer };
